export default __webpack_public_path__ + "static/media/earning.00f461a5.svg";